var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.57141H6.4286C4.06166 2.57141 2.14288 4.49019 2.14288 6.85713V15.4286C2.14288 17.7955 4.06166 19.7143 6.4286 19.7143H15C17.367 19.7143 19.2857 17.7955 19.2857 15.4286V6.85713C19.2857 4.49019 17.367 2.57141 15 2.57141Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1429 10.6028C14.2487 11.3162 14.1268 12.0447 13.7947 12.6849C13.4625 13.325 12.937 13.8441 12.2928 14.1683C11.6487 14.4925 10.9187 14.6054 10.2067 14.4908C9.4947 14.3762 8.83696 14.0401 8.32702 13.5301C7.81709 13.0202 7.48093 12.3625 7.36636 11.6505C7.25179 10.9385 7.36465 10.2085 7.68887 9.56431C8.01309 8.92015 8.53218 8.39462 9.17229 8.06248C9.81241 7.73034 10.541 7.60849 11.2543 7.71427C11.982 7.82217 12.6556 8.16124 13.1758 8.68139C13.6959 9.20154 14.035 9.8752 14.1429 10.6028Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 6.42859H15.4371",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7d789ace13bd8c49336c03735c760973.svg";
export { ForwardRef as ReactComponent };